<template>
    <div class="row">
        <DescriptionList
            v-if="extraServicesAndInfos.length"
            :items="extraServicesAndInfos"
            class="col-sm-6 list services-and-info"
        >
            <template slot="column1" slot-scope="slotProps">
                <span v-html="$t(slotProps.item.translationKey)"></span>
            </template>
            <template slot="column2" slot-scope="slotProps">
                <span v-if="slotProps.item.translationKey.includes('numberOfRooms')" class="">{{
                    slotProps.item.value
                }}</span>
                <span v-else>{{ slotProps.item.value }}</span>
            </template>
        </DescriptionList>

        <DescriptionList v-if="facilityTags.length" :items="facilityTags" class="facility-tags col-sm-6 list">
            <template slot="column1" slot-scope="slotProps">
                {{ $t('Facilities.' + slotProps.item.title) }}
            </template>
            <template slot="column2" slot-scope="slotProps">
                <CheckList :items="slotProps.item.entries" class="facility-list">
                    <span slot-scope="slotProps">
                        {{ slotProps.item.text }}
                    </span>
                </CheckList>
            </template>
        </DescriptionList>
    </div>
</template>

<script>
import CheckList from '@/components/product/CheckList';
import DescriptionList from '@/components/DescriptionList';

export default {
    name: 'Facilities',
    components: {
        CheckList,
        DescriptionList
    },
    props: {
        extraServices: {
            type: Array,
            required: true
        },
        additionalHotelInfos: {
            type: Array,
            required: true
        },
        facilityTags: {
            type: Array,
            required: true
        }
    },
    computed: {
        extraServicesAndInfos() {
            return [...this.additionalHotelInfos, ...this.extraServices];
        }
    }
};
</script>

<style lang="scss" scoped>
.list ::v-deep {
    td {
        &:first-child {
            vertical-align: top;
            white-space: nowrap;

            &::after {
                content: ':';
            }
        }
    }
}

.services-and-info ::v-deep {
    tr:first-child {
        td {
            padding-top: 10px;
        }
    }

    td {
        line-height: 22px;
        padding-top: 15px;
        padding-bottom: 15px;
    }
}

.facility-tags ::v-deep {
    tr:not(:first-child) {
        td {
            padding-top: 40px;
        }
    }

    td {
        line-height: 38px;

        .facility-list {
            li {
                padding: 0;
                padding-left: 25px;

                .tick-svg {
                    top: 10px;
                }
            }
        }
    }
}
</style>
